document.addEventListener("DOMContentLoaded", () => {
  const ageGateBtn = document.getElementById("age-gate-btn");
  const ageGate = document.getElementById("age-gate");

  checkCookie();

  function hideAgeGate() {
    ageGate.style.display = "none";
  }

  function displayAgeGate() {
    ageGate.style.display = "flex";
  }

  function getCookie() {
    let name = "age_gate=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let isOldEnough = getCookie();
    if (isOldEnough !== "") {
      hideAgeGate();
    } else {
      displayAgeGate();
    }
  }

  function setCookie() {
    const date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `age_gate=1; ${expires}; path=/`;
    hideAgeGate();
  }

  ageGateBtn?.addEventListener("click", setCookie);
});
